var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c("validation-provider", {
        attrs: { rules: _vm.requiredFields, name: _vm.validatorName },
        scopedSlots: _vm._u([
          {
            key: "default",
            fn: function(ref) {
              var errors = ref.errors
              return [
                _c("app-label", {
                  attrs: { label: _vm.getLabel(), required: _vm.required }
                }),
                _c(
                  "el-date-picker",
                  _vm._b(
                    {
                      staticClass: "input date",
                      class: { erro: errors.length },
                      attrs: {
                        type: "date",
                        placeholder: "Selecione",
                        format: "dd/MM/yyyy",
                        name: _vm.label,
                        "picker-options": _vm.pickerOptions
                      },
                      model: {
                        value: _vm.parent.date,
                        callback: function($$v) {
                          _vm.$set(_vm.parent, "date", $$v)
                        },
                        expression: "parent.date"
                      }
                    },
                    "el-date-picker",
                    _vm.$attrs,
                    false
                  )
                ),
                _c("span", { staticClass: "help erro" }, [
                  _vm._v(_vm._s(errors[0]))
                ])
              ]
            }
          }
        ])
      })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-2d1469eb", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-2d1469eb","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppData.vue
// module id = null
// module chunks = 